import { render, staticRenderFns } from "./Glosarium.vue?vue&type=template&id=acb4a098&"
import script from "./Glosarium.vue?vue&type=script&lang=js&"
export * from "./Glosarium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports